import React from 'react';
import { connect } from 'react-redux';
import { PdpState } from '@ff-os/pdp-shared-redux/store';
import { scenePlugins } from '@ff-os/pdp-shared-registry/index';

const _DesignerSlot = ({ scenePluginId }: Props) => {
    const plugin = scenePlugins.require(scenePluginId);
    const DesignerUi = plugin.ui.designer!;
    return <DesignerUi />;
};

type Props = {
    scenePluginId: string;
};

const mapStateToProps = (state: PdpState) => ({
    scenePluginId: state.scene.pluginId
});

export const DesignerSlot = connect(
    mapStateToProps
)(_DesignerSlot);